var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneySquareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3497",
    "data-name": "Rectangle 3497",
    width: 40.023,
    height: 50.969,
    fill: "#f2bd41"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6448",
    "data-name": "Groupe 6448",
    transform: "translate(0 0.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3490",
    "data-name": "Rectangle 3490",
    transform: "translate(0 -0.122)",
    fill: "#fdf6d9",
    stroke: "#f2bd41",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 86,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6437",
    "data-name": "Groupe 6437",
    transform: "translate(23.524 18.051)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5685",
    "data-name": "Trac\\xE9 5685",
    d: "M33.648,0H6.374A6.381,6.381,0,0,0,0,6.374V36.442a6.384,6.384,0,0,0,4.881,6.2v4.55a3.785,3.785,0,0,0,3.781,3.78h22.7a3.784,3.784,0,0,0,3.78-3.78v-4.55a6.384,6.384,0,0,0,4.881-6.2V6.374A6.381,6.381,0,0,0,33.648,0M25.3,7.664H14.723V2.986H25.3ZM4.881,6.371V39.482a3.391,3.391,0,0,1-1.894-3.04V6.374A3.392,3.392,0,0,1,6.374,2.986h5.363V4.728H6.524A1.645,1.645,0,0,0,4.881,6.371M32.155,47.188a.8.8,0,0,1-.794.794H8.661a.8.8,0,0,1-.794-.794V7.715h3.87V8.94a1.713,1.713,0,0,0,1.711,1.711H26.575A1.713,1.713,0,0,0,28.286,8.94V7.715h3.87Zm4.881-10.746a3.391,3.391,0,0,1-1.894,3.04V6.371A1.645,1.645,0,0,0,33.5,4.728H28.286V2.986h5.363a3.392,3.392,0,0,1,3.388,3.388Z",
    fill: "#f2bd41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5686",
    "data-name": "Trac\\xE9 5686",
    d: "M147.2,153.568a17.7,17.7,0,0,0-2.077-1.2q-1.119-.553-2.077-.917a5.074,5.074,0,0,1-1.605-.944,1.776,1.776,0,0,1-.647-1.362,1.758,1.758,0,0,1,.8-1.524,3.919,3.919,0,0,1,2.253-.553,5.531,5.531,0,0,1,2.4.513,5.076,5.076,0,0,0,1.322.512,1.148,1.148,0,0,0,1.025-.642,2.45,2.45,0,0,0,.378-1.242,1.417,1.417,0,0,0-.553-1.108,3.488,3.488,0,0,0-1.43-.693,13.793,13.793,0,0,0-1.659-.319c-.218-.027-.43-.047-.638-.062v-3.067a1.493,1.493,0,0,0-2.986,0v3.27c-.069.016-.138.032-.206.05a7.271,7.271,0,0,0-2.077.9,4.409,4.409,0,0,0-1.551,1.725,5.9,5.9,0,0,0-.108,4.866A4.366,4.366,0,0,0,139,153.392a10.773,10.773,0,0,0,1.7,1.093q.93.485,1.848.877t1.686.809a3.762,3.762,0,0,1,1.241,1.052,2.355,2.355,0,0,1,.472,1.443,1.991,1.991,0,0,1-.863,1.754,3.725,3.725,0,0,1-2.158.593,4.323,4.323,0,0,1-1.726-.336,3.958,3.958,0,0,1-1.2-.743,9.3,9.3,0,0,0-.863-.743,1.38,1.38,0,0,0-.8-.336,1.334,1.334,0,0,0-1.065.634,2.1,2.1,0,0,0-.472,1.255q0,1.241,1.834,2.293a8.019,8.019,0,0,0,3.066.974v3.341a1.493,1.493,0,1,0,2.986,0v-3.4a6.234,6.234,0,0,0,3-1.363,5.3,5.3,0,0,0,1.767-4.27,6.072,6.072,0,0,0-.647-2.873,5.036,5.036,0,0,0-1.605-1.875",
    transform: "translate(-123.179 -125.582)",
    fill: "#f2bd41"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySquareIcon);
export default __webpack_public_path__ + "static/media/money-square-icon.77d07471547876bc8ef40b02c3f82704.svg";
export { ForwardRef as ReactComponent };